export default __webpack_public_path__ + "static/media/logout.fbca07ce.svg";